module.exports = __webpack_public_path__ + "static/img/2-How-much-time-will-it-take-1024x1024.651c2a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2-How-much-time-will-it-take-1024x1024.png
// module id = fg2c
// module chunks = 0